export class UsuarioAutenticado {
    login = '';
    cpfCnpj = '';
    nomeCompleto = '';
    email = '';
    matricula = 0;
    selo = 0;
    seloDescricao = '';
    tipoUltimoAcessoId = 0;
    tipoUltimoAcessoDescricao = '';
}

export interface ArvoreMenuUsuario {
    nome?: string;
    url?: string | null;
    menuID?: number;
    arvoreDeMenu?: ArvoreMenuUsuario[];
    ArvoreDeMenu?: ArvoreMenuUsuario[];
}

export class Usuario {
    nome?: string;
    loginAD?: string;
    unidadeID?: number;
    nomeUnidade?: string;
    nomeGrupo?: string;
    grupoID?: number;
    dataUltimoAcesso?: string;
    sistemaId?: number;
    nomeSistema?: string;
    matricula?: number;
    email?: string;
    cpf?: string;
    endereco?: string;
    bairro?: string;
    cidade?: string;
    ip?: string;
    login?: string;
    selo?: number;
    seloDescricao?: string;
    siglaUnidade?: string;
    tipoUltimoAcessoId?: number;
    tipoUltimoAcessoDescricao?: string;
    loginRepresentado?: string;
    cpfCnpjIeRepresentado?: string;
    nomeRazaoSocialRepresentado?: string;
    arvoreMenu?: ArvoreMenuUsuario[];
    ArvoreMenu?: ArvoreMenuUsuario[];
    atalhosRapidos?: string[];
    atalhosRapidosArvoreMenu?: string[];
    usuarioAutenticado: UsuarioAutenticado = new UsuarioAutenticado();
    permissoes: string[] = [];
}
